var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CIcon',{staticClass:"ml-1",attrs:{"id":"show-hint","name":"cil-info","size":"sm","title":_vm.showTooltipHint(_vm.hint)}})
}
var staticRenderFns = []

export { render, staticRenderFns }